export default function menu() {
  const body = document.querySelector("body");
  const spMenu = document.querySelector(".sp-menu");

  document
    .querySelector("#site-header .menu-button")
    ?.addEventListener("click", () => {
      spMenu?.classList.add("is-open");
      body.classList.add("is-fixed");
    });

  document
    .querySelector(".sp-menu .close-button")
    ?.addEventListener("click", () => {
      spMenu?.classList.remove("is-open");
      body.classList.remove("is-fixed");
    });
}
